import { createSlice } from '@reduxjs/toolkit';

// Gradient color pairs - cycles through on each page navigation
// Uses CSS variables from variables.css for centralized color management
export const GRADIENT_COLORS = [
  { primary: 'var(--color-purple-glow-50)', secondary: 'var(--color-green-glow-45)' },   // purple + green
  { primary: 'var(--color-green-glow-50)', secondary: 'var(--color-orange-glow-45)' },   // green + orange
  { primary: 'var(--color-orange-glow-50)', secondary: 'var(--color-red-glow-45)' },     // orange + red
  { primary: 'var(--color-red-glow-50)', secondary: 'var(--color-yellow-glow-45)' },     // red + yellow
  { primary: 'var(--color-yellow-glow-50)', secondary: 'var(--color-purple-glow-45)' }, // yellow + purple
];

interface GradientState {
  currentIndex: number;
}

const initialState: GradientState = {
  currentIndex: 0,
};

const gradientSlice = createSlice({
  name: 'gradient',
  initialState,
  reducers: {
    incrementGradient: (state) => {
      state.currentIndex = (state.currentIndex + 1) % GRADIENT_COLORS.length;
    },
    resetGradient: (state) => {
      state.currentIndex = 0;
    },
  },
});

export const { incrementGradient, resetGradient } = gradientSlice.actions;
export const gradientReducer = gradientSlice.reducer;

// Selectors - use generic type to avoid circular import
export const selectCurrentGradient = (state: any) =>
  GRADIENT_COLORS[state.gradient.currentIndex % GRADIENT_COLORS.length];
